// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scheduleTemplateCard {
  background: #ffffff;
  border-radius: 16px;
  min-width: 529px;
  width: 36.73vw;
  display: inline-block;
  height: 165px;
  margin: 9px;
  padding: 24px;
}
.scheduleTemplateCard .container {
  text-align: left;
}
.scheduleTemplateCard .headerRow {
  display: flex;
  align-content: space-between;
}
.scheduleTemplateCard .headerRow .titleContainer {
  display: flex;
}
.scheduleTemplateCard .headerRow .titleContainer .image {
  display: inline-block;
}
.scheduleTemplateCard .headerRow .titleContainer .text {
  display: inline-block;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #333333;
  position: relative;
  bottom: 5px;
  left: 2px;
}
.scheduleTemplateCard .headerRow .dropDown {
  margin-left: auto;
}
.scheduleTemplateCard .dataContainer {
  text-align: left;
  margin-top: 17px;
}
.scheduleTemplateCard .dataContainer .hours {
  margin-top: 5px;
}
.scheduleTemplateCard .dataContainer .header {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #999999;
  display: inline-block;
}
.scheduleTemplateCard .dataContainer .data {
  display: inline-block;
  margin-left: 24px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.scheduleTemplateCard .workCard {
  padding: 2px 6px;
  gap: 10px;
  background: #f9e0da;
  border-radius: 4px;
  color: #874a3d;
  display: inline-block;
}
.scheduleTemplateCard .workCardSelective {
  padding: 2px 6px;
  gap: 10px;
  background: #d6eed9;
  border-radius: 4px;
  color: #2b6132;
  display: inline-block;
}
.scheduleTemplateCard .workCardAutonomous {
  padding: 2px 6px;
  gap: 10px;
  background: #d5e5f3;
  border-radius: 4px;
  color: #385b7d;
  display: inline-block;
}

.popup-content {
  margin: auto;
  width: 102px !important;
  padding: 16px;
  background-color: #ffffff !important;
  width: 102px;
  height: 84px;
  left: 1292.5px;
  border: 1px solid #e9e9e9;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
}
.popup-content .templateCardPopupContentMenuItem {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  cursor: pointer;
  padding-bottom: 6px;
}

.popup-arrow {
  visibility: hidden;
}

[role=tooltip].popup-content {
  width: 200px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 3px;
}

.templateCardPopupContentMenuItem:hover {
  background-color: rebeccapurple;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/screens/scheduleTemplate/scheduleTemplateCard/scheduleTemplateCard.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EAEA,qBAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;AAAJ;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,aAAA;EACA,4BAAA;AADR;AAEQ;EACI,aAAA;AAAZ;AACY;EACI,qBAAA;AAChB;AACY;EACI,qBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAChB;AAEQ;EACI,iBAAA;AAAZ;AAGI;EACI,gBAAA;EACA,gBAAA;AADR;AAEQ;EACI,eAAA;AAAZ;AAGQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AADZ;AAGQ;EACI,qBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADZ;AAKI;EACI,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AAHR;AAKI;EACI,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AAHR;AAKI;EACI,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AAHR;;AAOA;EACI,YAAA;EACA,uBAAA;EACA,aAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,4CAAA;AAJJ;AAMI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAJR;;AAOA;EACI,kBAAA;AAJJ;;AAMA;EACI,YAAA;EACA,2CAAA;AAHJ;;AAMA;EACI,+BAAA;EACA,YAAA;AAHJ","sourcesContent":[".scheduleTemplateCard {\n    background: #ffffff;\n    border-radius: 16px;\n    min-width: 529px;\n    width: 36.73vw;\n\n    display: inline-block;\n    height: 165px;\n    margin: 9px;\n    padding: 24px;\n\n    .container {\n        text-align: left;\n    }\n\n    .headerRow {\n        display: flex;\n        align-content: space-between;\n        .titleContainer {\n            display: flex;\n            .image {\n                display: inline-block;\n            }\n            .text {\n                display: inline-block;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 500;\n                font-size: 18px;\n                line-height: 24px;\n                color: #333333;\n                position: relative;\n                bottom: 5px;\n                left: 2px;\n            }\n        }\n        .dropDown {\n            margin-left: auto;\n        }\n    }\n    .dataContainer {\n        text-align: left;\n        margin-top: 17px;\n        .hours {\n            margin-top: 5px;\n        }\n\n        .header {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            color: #999999;\n            display: inline-block;\n        }\n        .data {\n            display: inline-block;\n            margin-left: 24px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #505054;\n        }\n    }\n\n    .workCard {\n        padding: 2px 6px;\n        gap: 10px;\n        background: #f9e0da;\n        border-radius: 4px;\n        color: #874a3d;\n        display: inline-block;\n    }\n    .workCardSelective {\n        padding: 2px 6px;\n        gap: 10px;\n        background: #d6eed9;\n        border-radius: 4px;\n        color: #2b6132;\n        display: inline-block;\n    }\n    .workCardAutonomous {\n        padding: 2px 6px;\n        gap: 10px;\n        background: #d5e5f3;\n        border-radius: 4px;\n        color: #385b7d;\n        display: inline-block;\n    }\n}\n\n.popup-content {\n    margin: auto;\n    width: 102px !important;\n    padding: 16px;\n    background-color: #ffffff !important;\n    width: 102px;\n    height: 84px;\n    left: 1292.5px;\n    border: 1px solid #e9e9e9;\n    box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n\n    .templateCardPopupContentMenuItem {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        color: #333333;\n        cursor: pointer;\n        padding-bottom: 6px;\n    }\n}\n.popup-arrow {\n    visibility: hidden;\n}\n[role='tooltip'].popup-content {\n    width: 200px;\n    box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 3px;\n}\n\n.templateCardPopupContentMenuItem:hover {\n    background-color: rebeccapurple;\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
